import DefaultEditor from "react-simple-wysiwyg";
import CollapseHeader from "../../core/common/collapse-header";

const PackagesAdd = () => {
  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Add Packages<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-body">
                    <div className="col-xs-12">
                      <div className="box">
                        <form method="post" role="form">
                          <input type="hidden" name="_token" />{" "}
                          <input
                            type="hidden"
                            className="form-control"
                            name="id"
                            value="1"
                            id="id"
                          />
                          <div className="box-body">
                            <h3 style={{ marginBottom: "20px" }}>
                              Package Details
                            </h3>
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label className="form-label">Name </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="company_name"
                                      id="company_name"
                                      value="name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label className="form-label">
                                    Is Active{" "}
                                  </label>
                                  <div className="select2-container select2-container--default status-label-container">
                                    <select
                                      className="form-select"
                                      name="mca_crm"
                                      id="enable_mca_crm"
                                    >
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label className="form-label">
                                    Display Order{" "}
                                  </label>
                                  <div className="select2-container select2-container--default status-label-container">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="company_name"
                                      id="company_name"
                                      value="display order"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-lg-12">
                                <div className="mb-3">
                                  <label className="col-form-label">
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <DefaultEditor className="summernote" />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                      <div className="col-xs-12">
                        <div className="box">
                          <div className="box-body">
                            <h3 style={{ marginBottom: "20px" }}>Module</h3>
                            <form method="post" role="form">
                              <input type="hidden" name="_token" />
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Show On
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="company_name"
                                        id="company_name"
                                        value="name"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Currency
                                    </label>
                                    <div className="input-daterange input-group col-sm-12 col-xs-12">
                                      <select className="form-select">
                                        <option value="#">USD</option>
                                        <option value="4">CAD</option>
                                        <option value="3">INR</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">Module</label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="company_name"
                                        id="company_name"
                                        value="name"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xs-12">
                        <div className="box">
                          <div className="box-body">
                            <h3 style={{ marginBottom: "20px" }}>
                              Package Price
                            </h3>
                            <form method="post" role="form">
                              <input type="hidden" name="_token" />
                              <div className="row mb-2">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Monthly
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="monthly"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4 mb-2">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Quaterly
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="quaterly"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Half Yearly
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="half yearly"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">Yearly</label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="yearly"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xs-12">
                        <div className="box">
                          <div className="box-body">
                            <h3 style={{ marginBottom: "20px" }}>Rate</h3>
                            <form method="post" role="form">
                              <input type="hidden" name="_token" />
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Call Rate Per Minute
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="Rate Per SMS"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Per SMS Send/Received
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="Rate Per SMS"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4 mb-2">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Per Phone No
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="Rate Per Phone No"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Per Fax Send/Received
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="Rate Per Fax"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Per Email
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="Rate Per Email"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xs-12">
                        <div className="box">
                          <div className="box-body">
                            <h3 style={{ marginBottom: "20px" }}>Free</h3>
                            <form method="post" role="form">
                              <input type="hidden" name="_token" />
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Free Call Minute
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="free Call"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Free SMS
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="free SMS"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4 mb-2">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Free FAX
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="free FAX"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Free Emails
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="free Emails"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Free Did
                                    </label>
                                    <div className="input-group">
                                      <span className="input-group-text ">
                                        <i className="ti-user"></i>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value="free DID"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                          </div>
                          <div  className="box-footer text-end">
                         
                         <button type="submit" id="submitbtn"  className="btn btn-primary me-2" >Update</button>
                         <button type="submit" id="submitbtn"  className="btn btn-secondary me-2" >Reset</button>
                         <button type="submit" id="submitbtn"  className="btn btn-primary me-2" >cancel</button>
                     </div>
                        </form>
                      </div>
                    </div>
                  
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* /Page Wrapper */}
      </>
    </>
  );
};

export default PackagesAdd;